import { ValueLabelOption } from '@elementary/common-ui/types';

export const YAML_FORM_SKIP_KEYS: string[] = ['config', 'name'];

export type YamlFormFieldType =
  | 'text'
  | 'autocomplete'
  | 'numeric'
  | 'decimal'
  | 'boolean'
  | 'multiAutocomplete'
  | 'stringList'
  | 'json'
  | 'object';

export type YamlFormOptionSource = 'columns' | 'timestampColumns' | 'tables';

export type YamlFormResourceOptions = {
  columns: ValueLabelOption[];
  timestampColumns: ValueLabelOption[];
  tables: ValueLabelOption[];
};

export type JsonSchemaType =
  | 'string'
  | 'number'
  | 'integer'
  | 'boolean'
  | 'array'
  | 'object'
  | 'null';

export type JsonSchema = {
  type?: JsonSchemaType | JsonSchemaType[];
  description?: string;
  properties?: Record<string, JsonSchema>;
  items?: JsonSchema;
  enum?: unknown[];
  required?: string[];
  additionalProperties?: boolean | JsonSchema;
  default?: unknown;
};

export type YamlFormField = {
  name: string;
  path: string[];
  label: string;
  description?: string;
  fieldType: YamlFormFieldType;
  required: boolean;
  enumValues?: string[];
  optionSource?: YamlFormOptionSource;
  children?: YamlFormField[];
};

export const EMPTY_YAML_FORM_RESOURCE_OPTIONS: YamlFormResourceOptions = {
  columns: [],
  timestampColumns: [],
  tables: [],
};

export type YamlFormValues = Record<string, unknown>;

export type YamlValidationError = {
  line: number;
  message: string;
};

export type EditorMode = 'form' | 'yaml';

export const isJsonSchema = (value: unknown): value is JsonSchema =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const isYamlFormValues = (value: unknown): value is YamlFormValues =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
